import { FC } from "react";
import { TextField, TextFieldProps } from "../../../inputs";
import { useTableContext, useTablePropsContext } from "../../context";

import { ReactComponent as SearchIcon } from "./icons/search.svg";


export const GlobalFilter:FC<TextFieldProps> = (props => {
  const table = useTableContext();
  const tableProps = useTablePropsContext();

  if (!tableProps?.enableGlobalFilter) {
    return null;
  }

  return (
    <TextField
      startAdornment={<SearchIcon />}
      placeholder="Search"
      isClearable
      {...props}
      value={table?.getState?.().globalFilter}
      onChange={table?.setGlobalFilter}
    />
  );
});